export default class nav {
    constructor(fadeIn, fadeOut) {
        const navBtn = document.querySelector("header .btns button");
        const gNav = document.querySelector(".gNav");
        const navLink = gNav.querySelectorAll("ul > li > a");
        console.log(navBtn);
        let navFlg = false;
        navBtn.addEventListener("click", function () {
            if (navFlg === false) {
                navBtn.classList.add('act');
                fadeIn(gNav, 100);
                navFlg = true;
            } else {
                navBtn.classList.remove('act');
                fadeOut(gNav, 100);
                navFlg = false;
            }
        })
        navLink.forEach(function (i) {
            i.addEventListener("click", function () {
                // console.log(i.getAttribute("href").indexOf('#'));
                if (i.getAttribute("href").startsWith('#') !== '-1') {
                    navBtn.classList.remove('act');
                    fadeOut(gNav, 100);
                    navFlg = false;
                }
            })
        })
    }
}